import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  KENMERK_GROUP: `${cleanedFilename(__filename)}-kenmerk-group`,
};
